import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ConflictCase } from '@app/models/conflictCase.model';
import { OfferService } from './offer.service';

@Injectable()
export class ConflictCaseService {
  baseHref = `${environment.apiUrl}/conflicts`;

  constructor(
    private http: HttpClient,
    private offerService: OfferService,
  ) {}

  getConflictCase(uuid: string): Observable<ConflictCase> {
    const url = `${this.baseHref}/get-conflict-case/${uuid}`;
    return this.http.get<ConflictCase>(url);
  }

  submitEvidence(
    accessId: string,
    description: string,
    media: any = null,
  ): Observable<any> {
    const url = `${this.baseHref}/create-conflict-case-evidence`;
    return this.http.post<any>(url, {
      accessId,
      description,
      media,
    });
  }
}
